type FilterOption = { label: string; value: string };

type FilterGroupProps = {
  title: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  grid?: boolean;
};

export default function FilterGroup({ title, options, value, onChange, grid = false }: FilterGroupProps) {
  return (
    <div>
      <h3 className="text-xs font-medium text-foreground-500 mb-2.5">{title}</h3>
      <div className={grid ? "grid grid-cols-2 gap-1.5" : "flex flex-wrap gap-1.5"}>
        {options.map((option) => {
          const active = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              aria-pressed={active}
              className={`px-2.5 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}